import React from 'react';
// STYLE
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
// UTILS
import get from 'lodash.get';
// CONSTANTS
import {
  ITEM_TABLE_HEADER,
  ITEM_TABLE_HEADER_IN_MOBILE,
} from '../ItemsTableHead/tableHeaders';
// COMPONENTS
import HoldingsTableOperationColumn from '../../../../HoldingsTable/HoldingsTableOperationColumn/HoldingsTableOperationColumn';
import { getValueFromMarc } from '../../../../../utils/marc';
import { useMediaQuery, useTheme } from '@material-ui/core';

const ItemsTableBody = ({
  itemData = [],
  me,
  setReservationData,
  setRequestData,
  periodicalType,
  bib,
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only('xs'), { noSsr: true });

  const headerConfig = matches
    ? ITEM_TABLE_HEADER_IN_MOBILE
    : ITEM_TABLE_HEADER;

  const getMetadataValue = (item, header) => {
    const { metadataKey } = header;
    const { extraMetaDatas_m2m = [] } = item;

    const value = extraMetaDatas_m2m.find(metadata => {
      const { metaDataType } = metadata;

      return metaDataType.code === metadataKey;
    })?.value;

    return value ?? '-';
  };

  const isSissItemWithoutBarcode = node => {
    return (
      (periodicalType === 'siss' ||
        [
          'SISS()',
          'SISS',
          'Issue',
          '1ff418f8-a5d3-5afe-a0db-6b37774c3a7a',
        ].includes(
          getValueFromMarc('901', 'a', bib?.rawMarcRecord, 'value')
        )) &&
      !node?.barcode
    );
  };

  return (
    <TableBody>
      {itemData?.length === 0 && (
        <TableRow>
          <TableCell colSpan={7} style={{ textAlign: 'center' }}>
            Nincs adat
          </TableCell>
        </TableRow>
      )}
      {itemData?.map(node => {
        return (
          <TableRow key={node?.guid}>
            {headerConfig.map(header => {
              if (header.ref === 'operations') {
                /**
                 * OKPD-10284 - Ideiglenesen elrejjtjük az operation-öket, hogy ne lehessen vonalkód nélküli sisseket foglalni/előjegyezni
                 */
                if (isSissItemWithoutBarcode(node)) return null;

                return (
                  <TableCell key={header.ref}>
                    <HoldingsTableOperationColumn
                      item={node}
                      me={me}
                      setReservationData={setReservationData}
                      setRequestData={setRequestData}
                    />
                  </TableCell>
                );
              }

              if (header.metadataKey) {
                return (
                  <TableCell key={header.ref}>
                    {getMetadataValue(node, header)}
                  </TableCell>
                );
              }

              if (header?.key === 'semanticStatus') {
                let content = get(
                  node,
                  'semanticStatus.displayName',
                  'Hozzáférhető'
                );

                // if (node?.hasActiveLoan) content = 'Kikölcsönzött';
                // if (node?.hasRequests) content = 'Előjegyzett';
                // if (node?.hasReservation) content = 'Foglalt';
                // if (node?.hasActiveLoan && node?.hasRequests)
                //   content = 'Előjegyzett';

                return <TableCell key={header.ref}>{content}</TableCell>;
              }

              let resolveDisplayName = get(node, header.ref);
              return (
                <TableCell key={header.ref}>
                  {resolveDisplayName ? resolveDisplayName : '-'}
                </TableCell>
              );
            })}
          </TableRow>
        );
      })}
    </TableBody>
  );
};

export default ItemsTableBody;
